import ParcelService from '../../services/ParcelService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'

export const namespaced = true

const initialState = {
  parcels: [],
  selectedParcel: null,
  status: null
}

export const state = {
  parcels: [],
  selectedParcel: null,
  status: null
}

export const mutations = {
  SET_PARCELS(state, recs) {
    state.parcels = recs
  },
  SET_SELECTED_PARCEL(state, rec) {
    state.selectedParcel = rec
  },
  SET_PARCEL_VALUE(state, status) {
    state.status = status
  },
  RESET_STATUS_VALUE(state) {
    state.status = null
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchParcels: function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ParcelService.getParcelsForMasterplan(
      context.rootGetters['MasterplanStore/getSelectedMasterplanId']
    ).then(
      r => {
        context.commit('SET_PARCELS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_PARCELS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedParcel: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ParcelService.getParcelById(value).then(
      r => {
        context.commit('SET_SELECTED_PARCEL', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'PARCEL ',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_PARCEL', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  addParcel: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ParcelService.addParcel(value).then(context.dispatch('fetchParcels'))
  },
  updateParcel: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ParcelService.updateParcel(value).then(
      res => {
        context.commit('SET_SELECTED_PARCEL', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'PARCEL ',
            name: res.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        context.dispatch('fetchParcels')
        context.dispatch(
          'NotificationStore/add',
          { type: 'info', message: 'Parcel data successfully updated' },
          { root: true }
        )
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  // Duplicates each given parcel `copies` times. Each duplicate drops the
  // original's id (so it's created as a new record) and externalId (reserved
  // for CRM sync — a copy is not the same real-world parcel), and gets a
  // "<name> copy (<n>)" suffix per copy number. Batches all creations then
  // refetches once, rather than relying on addParcel's per-call refetch.
  copyParcels: async function(context, { parcels, copies }) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      const creations = []
      parcels.forEach(parcel => {
        for (let i = 1; i <= copies; i++) {
          const clone = Object.assign({}, parcel)
          delete clone.id
          clone.externalId = ''
          clone.name = `${parcel.name} copy (${i})`
          creations.push(ParcelService.addParcel(clone))
        }
      })
      await Promise.all(creations)
      await context.dispatch('fetchParcels')
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      context.dispatch(
        'NotificationStore/add',
        {
          type: 'info',
          message: `Created ${creations.length} parcel ${
            creations.length === 1 ? 'copy' : 'copies'
          }`
        },
        { root: true }
      )
    } catch (error) {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(error, context, router)
      throw error
    }
  },
  deleteParcel: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      return await ParcelService.deleteParcel(value)
    } catch (error) {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(error, context, router)
      throw error
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  resetStatusValue: function(context) {
    context.commit('RESET_STATUS_VALUE')
  }
}

export const getters = {
  getSelectedParcelId: state => {
    return state.selectedParcel ? state.selectedParcel.id : 0
  }
}
